
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Search from 'vux/src/components/search/index.vue'

export default {
name: 'ApplyTryPage',
components: {
XInput,
XButton,
Group,
Cell,
Msg,
Selector,
Datetime,
Search
},
data () {
return {
formParam: {
complainant: '',
complainant_mobile: '',
complainType: '',
projectName: '',
complainContent: '',
complainDate: this.$Utils.dateFormat(new Date(), 'yyyy-MM-dd'),
submitUser: '',
submit_user_mobile: '',
remark: '',
accept_manager: '',
accept_manager_mobile: ''
},
complainTypeList: [{key: '沟通态度类', value: '沟通态度类'}, {key: '技术服务类', value: '技术服务类'}, {key: '恶劣性质类', value: '恶劣性质类'}],
managerList: [],
staffList: [],
results: [],
submitSuccess: false,
searchFlag: false,
searchValue: '',
searchType: '',
buttons: [{
type: 'default',
text: '关闭',
onClick: this.closePage.bind(this)
}]
}
},
mounted: function () {
this.getManagerList()
this.getStaffList()
},
methods: {
closePage: function () {


},
search: function (type) {
console.log(type)
let that = this
that.searchFlag = true
that.searchType = type
that.searchValue = ''
let oriList = []
if (that.searchType === 'staff') {
oriList = that.staffList
} else if (that.searchType === 'submitUser') {
oriList = that.staffList
}

that.results = []
for (var i = 0; i < oriList.length; i++) {
var item = oriList[i]
that.results.push({title: item.value, mobile: item.key})
}
},
searchClick: function (item) {
let that = this
console.log(item)
if (that.searchType === 'staff') {
that.formParam.complainant = item.title
that.formParam.complainant_mobile = item.mobile
} else if (that.searchType === 'submitUser') {
that.formParam.submitUser = item.title
that.formParam.submit_user_mobile = item.mobile
}
that.searchFlag = false
},
getResult: function (keyword) {
let that = this
let oriList = []
if (that.searchType === 'staff') {
oriList = that.staffList
} else if (that.searchType === 'submitUser') {
oriList = that.staffList
}

if (keyword == null || keyword.length === 0) {
that.results = []
for (var i = 0; i < oriList.length; i++) {
var item = oriList[i]
that.results.push({title: item.value, mobile: item.key})
}
} else {
that.results = []
oriList.filter(function (item) {
return item['value'].indexOf(keyword) >= 0
}).forEach(function (item) {
that.results.push({title: item.value, mobile: item.key})
})
}
},
getManagerList: function () {
let that = this
let url = '/wxapi/user/getManagerList'
that.$axios.post(url).then(function (res) {
if (res.meta.success) {
that.managerList = res.data
console.log(that.managerList)
}
})
},
getStaffList: function () {
let that = this
let url = '/wxapi/user/getStaffList'
that.$axios.post(url).then(function (res) {
if (res.meta.success) {
that.staffList = res.data
}
})
},
submitApply: function () {
let that = this
let url = '/wxapi/user/submitCustomerComplain'
console.log(that.$refs.accept_manager.getFullValue())
that.formParam.accept_manager = that.$refs.accept_manager.getFullValue()[0]['value']
console.log(that.formParam)
this.$axios.post(url, that.formParam).then(function (res) {
if (res.meta.success) {
that.submitSuccess = true
} else {
console.error(res.meta.message)
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}).catch(function (error) {
console.info(error)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/user/CustomerComplain.vue